import type {
  CategoryFilterCategory,
  CategoryFiltersResponse,
  CategoryFiltersWireResponse,
} from '@/types/categoryFilters.types';

/**
 * Coerce a BQ catalog id to string without passing through `Number()` (unsafe for INT64).
 * Prefer BFF JSON with string ids; when the wire sends numbers, only safe integers are exact.
 */
export function normalizeBqCatalogId(id: unknown): string {
  if (typeof id === 'string') {
    const trimmed = id.trim();
    return trimmed || '0';
  }
  if (typeof id === 'number' && Number.isFinite(id)) {
    return String(id);
  }
  return String(id);
}

export function normalizeCategoryFiltersResponse(
  data: CategoryFiltersWireResponse
): CategoryFiltersResponse {
  return {
    categories: data.categories.map(
      (c): CategoryFilterCategory => ({
        id: normalizeBqCatalogId(c.id),
        name: c.name,
        code: typeof c.code === 'string' ? c.code.trim() || undefined : undefined,
        segments: c.segments.map(s => ({
          id: normalizeBqCatalogId(s.id),
          name: s.name,
          code: typeof s.code === 'string' ? s.code.trim() || undefined : undefined,
        })),
      })
    ),
  };
}
